@if (this.isMulti()) {
  <elcia-multi-dropdown [control]="control()"
                        [items]="legalEntities()"
                        [label]="'entity.legal-entities' | translate"
                        [textField]="'name'"/>
} @else {
  <elcia-dropdown [control]="control()"
                  [items]="legalEntities()"
                  [label]="'entity.legal-entity' | translate"
                  [textField]="'name'"/>
}
